export const splitTaxesExperience = (amount, exp) => {
  let taxData = exp.taxes || [];

  let formData = {
    taxes: {},
    taxesTotal: 0,
    surCharges: {},
    surChargesTotal: 0
  };
  for (let i = 0; i < taxData.length; i++) {
    if (taxData[i].taxType === 'TAX') {
      formData['taxes'][taxData[i].code] = (amount * parseFloat(taxData[i].value)) / 100;
      formData['taxesTotal'] += (amount * parseFloat(taxData[i].value)) / 100;
    } else {
      formData['surCharges'][taxData[i].code] = (amount * parseFloat(taxData[i].value)) / 100;
      formData['surChargesTotal'] += (amount * parseFloat(taxData[i].value)) / 100;
    }
  }
  return formData;
};

